import { cva, type VariantProps } from 'class-variance-authority';

/**
 * A badge knows TONES, never domain values.
 *
 * `approved → success` is a domain mapping and lives in the module that owns
 * the domain (W9: the kit holds no domain string and no domain vocabulary).
 * Every tone is a token tint, which is why the preset's `<alpha-value>` fix had
 * to land before this file could exist at all.
 */
export const badgeVariants = cva(
  'inline-flex items-center gap-xs whitespace-nowrap rounded-full px-md py-0.5 text-tiny font-medium',
  {
    variants: {
      tone: {
        neutral: 'bg-muted text-muted-foreground',
        info: 'bg-primary/10 text-primary',
        success: 'bg-success/15 text-success',
        warning: 'bg-warning/15 text-warning',
        danger: 'bg-destructive/15 text-destructive',
        accent: 'bg-accent/20 text-accent-foreground',
      },
      variant: {
        soft: '',
        outline: 'border border-border bg-transparent',
      },
    },
    defaultVariants: { tone: 'neutral', variant: 'soft' },
  },
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;
export type BadgeTone = NonNullable<BadgeVariants['tone']>;
